/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _actions = require("../redux/actions");
var _selectors = require("../redux/selectors");
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    coordinateData: (0, _selectors.getAllCoordinateDataForId)(state, props.dataId)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
  return {
    onLoadCoordinates: function onLoadCoordinates(coordinates) {
      var dataId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.dataId;
      return dispatch((0, _actions.getDataForCoordinates)(coordinates, props.onLoadCoordinateData, dataId));
    },
    onLoadCoordinate: function onLoadCoordinate(coordinate) {
      var dataId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.dataId;
      return dispatch((0, _actions.getDataForCoordinate)(coordinate, props.onLoadCoordinateData, dataId));
    }
  };
};
var _default = function _default(DataGrid) {
  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DataGrid);
};
exports["default"] = _default;